<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Seguro/Garantia"
                @click.stop="abrirModal()"
            ></i>
        </span>
		<b-modal
			v-model="showModal"
			id="modalAtualizarSeguro"
			hide-footer
		>
			<div slot="modal-title">
				Seguros/Garantias -
				<b-badge variant="warning">Atualizar</b-badge>
			</div>
			<seguros-form
				tipoOperacao="a"
				:showModal="showModal"
				@modalFechado="showModal = false"
				@obterSegurosAtualizados="$emit('obterSegurosAtualizados')"
				:seguro="seguro"
				:contrato="contrato"
			></seguros-form>
		</b-modal>
    </div>
</template>

<script>
import SegurosForm from './SegurosForm'

export default {
	components: {
		SegurosForm
	},

	props: {
		contrato: {
			type: Object,
			default: () => ({})
		},

		seguro: {
			type: Object,
			default: () => ({})
		},
	},

	data() {
		return {
			showModal: false
		}
	},

	methods: {
		abrirModal() {
			this.showModal = true
		}
	},

	created() {},

	computed: {},

	watch: {},

	validations: {}
}
</script>
